export default __webpack_public_path__ + "static/media/life20button.b8f480dc.png";